// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('orderHeadChoices', {
//         templateUrl: 'views/components/views/orderHeadChoices/orderHeadChoices.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'ttGridFactory', function ($stateParams, ttGridFactory) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let orderInternalNo = $stateParams.order_internal_no;

//             vm.model = {
//                 gridReady: false
//             };

//             vm.grid = new ttGridFactory({
//                 rememberId: 'w_orderheadchoices_grid',
//                 kendo: {
//                     height: '100%',
//                     sortable: true,
//                     aggregate: true,
//                     pager: false,
//                     selectable: false,
//                     filterable: false
//                 }
//             });
            
//             // #endregion VARIABLES & DEFINITIONS

//             // #region GRID PROCEDURE FUNCTION CALLS

//             async function loadGrid() {
//                 vm.grid.dataTask.loadData = {
//                     method: 3744,
//                     parameters: { order_internal_no: orderInternalNo }
//                 };

//                 vm.model.gridReady = true;

//                 if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//             }

//             // #endregion GRID PROCEDURE FUNCTION CALLS

//             // #region ON INIT FUNCTION

//             vm.$onInit = function () {
//                 loadGrid();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
